import * as Sentry from '@sentry/browser';
var C = require('../constants.js.erb')

var shouldCapture = function(err) {
  var shouldCaptureError = true;
  var msg;

  if (_.isString(err)) { msg = err; }
  else {
    var msg = (err || {}).message
  }

  _.forEach(C.SKIP_ERRORS, function(skip) {
    if (_.includes(msg, skip)) {
      shouldCaptureError = false;
      return;
    }
  })
  return shouldCaptureError;
}

var setupSentry = function(C, $provide) {
  window.sentryContext = {};
  if (C.SENTRY_URL) {
    $provide.decorator('$exceptionHandler', ['$delegate', ($delegate) => {
      return (err, cause) => {
        $delegate(err, cause);
        if (shouldCapture(err)) {
          Sentry.withScope(scope => {
            scope.setExtra('context', sentryContext);
            scope.setExtra('cause', cause);
            Sentry.captureException(err);
          });
        }
      };
    }]);
  }
}

export default setupSentry;
